import { useEffect, useRef, useState } from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import { useParams, Link } from "react-router-dom";
import projects from "../data/projects";
import lottie from "lottie-web";
import ScrollCanvas from "../components/ScrollCanvas";
import LottieColorView from "./LottieColorView";
import { VideoJS } from "./VideoJS"; // Nouveau composant externe fiable

function ProjectDetails() {
  const { id } = useParams();
  const project = projects.find((proj) => proj.image.includes(`/img/${id}/`));

  const containerRefs = useRef([]);
  const [animationsData, setAnimationsData] = useState([]);
  const [loadedAnimations, setLoadedAnimations] = useState([]);

  const isURL = (str) =>
    str.startsWith("http://") || str.startsWith("https://");

  // useEffect(() => {
  //   async function loadAnimations() {
  //     if (project?.animations?.length > 0) {
  //       try {
  //         const dataArray = await Promise.all(
  //           project.animations.map((a) =>
  //             isURL(a.name)
  //               ? fetch(a.name)
  //                   .then((res) => res.text())
  //                   .then((text) => JSON.parse(text))
  //               : import(`../assets/${a.name}/data.json`).then(
  //                   (mod) => mod.default
  //                 )
  //           )
  //         );
  //         setAnimationsData(dataArray);
  //       } catch (err) {
  //         console.error("Erreur lors du chargement des animations :", err);
  //       }
  //     }
  //   }
  //   loadAnimations();
  // }, [project?.animations]);
  useEffect(() => {
    async function loadAnimations() {
      if (project?.animations?.length > 0) {
        try {
          const dataArray = await Promise.all(
            project.animations.map((a) => {
              const path = isURL(a.name)
                ? a.name
                : `/assets/${a.name}/data.json`; // ← ici ça va chercher dans public

              return fetch(path).then((res) => {
                if (!res.ok) throw new Error(`Erreur HTTP: ${res.status}`);
                return res.json();
              });
            })
          );

          setAnimationsData(dataArray);
        } catch (err) {
          console.error("Erreur lors du chargement des animations :", err);
        }
      }
    }

    loadAnimations();
  }, [project?.animations]);

  useEffect(() => {
    animationsData.forEach((data, index) => {
      const container = containerRefs.current[index];
      if (container) {
        const anim = lottie.loadAnimation({
          container,
          renderer: "svg",
          loop: true,
          autoplay: false,
          animationData: data,
        });

        anim.addEventListener("DOMLoaded", () => {
          setLoadedAnimations((prev) => {
            const updated = [...prev];
            updated[index] = true;
            return updated;
          });
          anim.play();
        });

        return () => anim.destroy();
      }
    });
  }, [animationsData]);

  if (!project) return <p>Projet introuvable</p>;

  return (
    <ParallaxProvider>
      <div
        className={`container-fluid project-${project.title
          .toLowerCase()
          .replace(/\s+/g, "-")}`}
      >
        <Link to="/" className="btn btn-secondary mt-4 persoBack">
          ← Retour
        </Link>

        {project.canvasSequence?.folder && (
          <ScrollCanvas
            folder={project.canvasSequence.folder}
            frameCount={project.canvasSequence.frameCount}
          />
        )}

        <div className="row projetPage">
          <div className="col-md-4">
            <div className="left-column p-5">
              <h1>{project.title}</h1>
              <div className="mb-3">
                {project.tags?.map((tag, index) => (
                  <span key={index} className="badge bg-secondary me-2">
                    {tag}
                  </span>
                ))}
              </div>
              <p>{project.description}</p>
            </div>

            {project.designConcepts?.length > 0 && (
              <div className="p-5 pt-0 blocInfo">
                <div className="row text-center justify-content-center">
                  {project.designConcepts.map((concept, index) => (
                    <div key={index} className="col-sm-12 mb-4">
                      {concept.icon && (
                        <img
                          src={`${process.env.PUBLIC_URL}${concept.icon}`}
                          alt={concept.alt || ""}
                          className="mb-2"
                          style={{ width: "50px" }}
                        />
                      )}
                      <p className="small">{concept.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="col-md-8 right-column">
            {project.customView === "LottieColorView" && (
              <div className="my-4 d-flex justify-content-center">
                <LottieColorView />
              </div>
            )}

            {project.animations?.map((anim, index) => (
              <div
                key={`anim-${index}`}
                className="my-4 d-flex justify-content-center animationLottie"
              >
                {!loadedAnimations[index] && <p>Chargement de l'animation…</p>}
                <div
                  ref={(el) => (containerRefs.current[index] = el)}
                  className={loadedAnimations[index] ? "" : "d-none"}
                ></div>
              </div>
            ))}

            {project.videos?.map((video, index) => {
              if (video.type === "vimeo" || video.type === "youtube") {
                return (
                  <div key={`video-${index}`} className="mb-4 aspect-video">
                    <iframe
                      src={video.src}
                      title={`video-${index}`}
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                      className="w-full h-full"
                    />
                  </div>
                );
              }

              if (video.type === "mp4") {
                return (
                  <div key={`video-${index}`} className="mb-4">
                    <VideoJS
                      options={{
                        autoplay: false,
                        controls: true,
                        responsive: true,
                        fluid: true,
                        sources: [
                          {
                            src: video.src,
                            type: video.mimeType || "video/mp4",
                          },
                        ],
                      }}
                      onReady={(player) => {
                        player.on("play", () => {
                          player.pauseOthers?.();
                        });
                      }}
                    />
                  </div>
                );
              }

              return null; // fallback
            })}

            {project.images?.map((img, index) => (
              <img
                src={img}
                alt={`${project.title} ${index}`}
                key={index}
                className="img-fluid mb-3"
              />
            ))}
          </div>
        </div>
      </div>
    </ParallaxProvider>
  );
}

export default ProjectDetails;
